import { useQuery } from '@tanstack/react-query';
import { storeService } from 'app/javascript/services/store';

// Fetches an academy's public store catalog. A missing store is a normal 404,
// so retry defaults to false (no point retrying a "no store" answer); callers
// can override. Catalog data is static/mock, hence the generous staleTime.
export function useStoreCatalog(slug: string, options?: { retry?: boolean | number }) {
  return useQuery({
    queryKey: ['store-catalog', slug],
    queryFn: () => storeService.getCatalog(slug),
    enabled: !!slug,
    staleTime: 5 * 60 * 1000,
    retry: options?.retry ?? false,
  });
}

// Fetches a single product for the detail page. Same 404-is-normal rationale as
// the catalog hook (a bad deep link should fall straight to the empty state).
export function useStoreProduct(slug: string, productId: string, options?: { retry?: boolean | number }) {
  return useQuery({
    queryKey: ['store-product', slug, productId],
    queryFn: () => storeService.getProduct(slug, productId),
    enabled: !!slug && !!productId,
    staleTime: 5 * 60 * 1000,
    retry: options?.retry ?? false,
  });
}
